import React, { Component } from 'react'
import reactMixin from 'react-mixin'
import Alerta from './Alerta'
import Servicios from './Servicios'
import Experiencia from './Experiencia'
import Comentarios from './Comentarios'
import Contacto from './Contacto'
import ReactFireMixin from 'reactfire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import update from 'immutability-helper'
import Sucursales from './Sucursales'
import RecomendationScale from './RecomendationScale'

const config = {
  apiKey: 'AIzaSyD3P4vc9OhjnXOO8fyxvDPkbSVe_q7K6cs',
  authDomain: 'lestat-372c8.firebaseapp.com',
  databaseURL: 'https://lestat-372c8.firebaseio.com',
  storageBucket: 'lestat-372c8.appspot.com',
  messagingSenderId: '985930702687'
}
firebase.initializeApp(config)

const initialState = {
  recomendationScaleValue: undefined,
  servicioText: '',
  servicioValues: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
  experienciaValues: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
  comentariosText: '',
  sugerenciasText: '',
  contactoValue: undefined,
  alert_open: false,
  alert_option: 1,
  location: {},
  sucursal: 0
}

class HomeModule extends Component {
  constructor(props) {
    super(props)
    this.state = initialState
  }

  onRecomendationScaleValue(event) {
    this.setState({
      recomendationScaleValue: event
    })
  }

  onServicioValue(newState, value, index) {
    var data = this.state.servicioValues
    var updatedOption = update(data[index], {
      title: {
        $set: newState
      },
      value: {
        $set: value
      }
    })
    var newData = update(data, {
      $splice: [[index, 1, updatedOption]]
    })
    this.setState({
      servicioValues: newData
    })
  }

  onServicioText(event) {
    const newState = event.target.value
    this.setState({
      servicioText: newState.toUpperCase()
    })
  }

  onExperienciaValue(newState, value, index) {
    var data = this.state.experienciaValues
    var updatedOption = update(data[index], {
      title: {
        $set: newState
      },
      value: {
        $set: value
      }
    })
    var newData = update(data, {
      $splice: [[index, 1, updatedOption]]
    })
    this.setState({
      experienciaValues: newData
    })
  }

  onComentariosText(event) {
    const newState = event.target.value
    this.setState({
      comentariosText: newState.toUpperCase()
    })
  }

  onSugerenciasText(event) {
    const newState = event.target.value
    this.setState({
      sugerenciasText: newState.toUpperCase()
    })
  }

  onContactoValue(newState) {
    this.setState({
      contactoValue: newState.toUpperCase()
    })
  }

  closeAlert() {
    window.location.reload()
  }
  openAlert() {
    this.setState({
      alert_open: true
    })
  }

  saveSurvey() {
    const nameRef = firebase
      .database()
      .ref()
      .child('surveys')
    const date = new Date()
    const survey = {
      pregunta0: {
        value: this.state.recomendationScaleValue
      },
      pregunta3: {
        text: this.state.servicioText,
        options: {
          option1: this.state.servicioValues[0].value,
          option2: this.state.servicioValues[1].value,
          option3: this.state.servicioValues[2].value,
          option4: this.state.servicioValues[3].value,
          option5: this.state.servicioValues[4].value,
          option6: this.state.servicioValues[5].value,
          option7: this.state.servicioValues[6].value,
          option8: this.state.servicioValues[7].value,
          option9: this.state.servicioValues[8].value,
          option10: this.state.servicioValues[9].value,
          option11: this.state.servicioValues[10].value,
          option12: this.state.servicioValues[11].value,
          option13: this.state.servicioValues[12].value
        }
      },
      pregunta4: {
        text: this.state.comentariosText
      },
      pregunta5: {
        text: this.state.sugerenciasText
      },
      pregunta6: {
        value: this.state.contactoValue
      },
      pregunta8: {
        options: {
          option1: this.state.experienciaValues[0].value,
          option2: this.state.experienciaValues[1].value,
          option3: '',
          option4: this.state.experienciaValues[3].value,
          option5: this.state.experienciaValues[4].value,
          option6: this.state.experienciaValues[5].value,
          option7: this.state.experienciaValues[6].value
        }
      },
      date: date.getTime(),
      sucursal: this.state.sucursal,
      location: this.state.location
    }
    nameRef.push(survey, () => {
      this.openAlert()
    })
  }

  printState() {
    if (this.state.sucursal > 0) {
      if (
        this.state.contactoValue
      ) {
        var canSave = true;
        for (var i in this.state.servicioValues) {
          if (!this.state.servicioValues[i].value) {
            canSave = false;
            alert('Por favor, llena todos los campos');
            break;
          }
        }
        if (canSave) this.saveSurvey();
      } else {
        alert('Por favor, llena todos los campos');
      }
    } else {
      alert('Por favor, elige una sucursal');
    }
  }

  openPrivacidad() {
    window.open('https://sportium.com.mx/encuesta/documents/privacidad.pdf', '_blank')
  }

  getIpAddress() {
    fetch(`//freegeoip.net/json/?callback`).then(result => {
      result.json().then(data => {
        this.setState({
          location: data
        })
      })
    })
  }

  componentDidMount() {
    if (this.props.match.params['id']) {
      //this.setState({sucursal: this.props.match.params['id']}, () => console.log(this.state.sucursal));
    }
    this.getIpAddress()
  }

  getSucursal(sucursal) {
    console.log(sucursal)
    if (sucursal.ruta === 'coapa') {
      this.setState({
        sucursal: '10'
      })
    } else {
      this.setState({
        sucursal: sucursal.key
      })
    }
  }

  render() {
    return (
      <div className="survey-container">
        <header className="survey-header">
          <div> </div>
        </header>
        <div className="survey-image-head">
          <span> Encuesta de Satisfacción </span>
        </div>{' '}
        <div className="survey-intro-text">
          {' '}
          Para <span> Sportium </span> lo más importante es tu bienestar, es por eso que
          constantemente estamos buscando la forma de mejorar nuestro servicio.{' '}
          <span> ¡Queremos escucharte! </span>
        </div>
        <div className="survey-questions-container">
          <div className="survey-obligatory-note"> * Obligatorio </div>{' '}
          <Sucursales onOptionSelected={sucursal => this.getSucursal(sucursal)} />
          <RecomendationScale
            callbackParent={newState => this.onRecomendationScaleValue(newState)}
          />
          <Servicios
            callbackValue={(newState, value, index) => this.onServicioValue(newState, value, index)}
            callbackText={event => this.onServicioText(event)}
          >
            {' '}
          </Servicios>
          <Experiencia
            callbackValue={(newState, value, index) =>
              this.onExperienciaValue(newState, value, index)
            }
          >
            {' '}
          </Experiencia>
          <Comentarios
            name="COMENTARIOS Y SUGERENCIAS"
            callbackText={event => this.onComentariosText(event)}
          >
            {' '}
          </Comentarios>
          <Comentarios
            name="NOMBRE O NÚMERO DE USUARIO (OPCIONAL)"
            callbackText={event => this.onSugerenciasText(event)}
          >
            {' '}
          </Comentarios>
          <Contacto
            callbackValue={newState => this.onContactoValue(newState)}
            optionSelected={this.contactoValue}
          >
            {' '}
          </Contacto>
          <div className="survey-button-send">
            <span onClick={() => this.printState()}> Enviar </span> <i className="btn-send"> </i>{' '}
          </div>{' '}
        </div>{' '}
        <div className="survey-bottom">
          <div className="chevron"> </div>{' '}
          <div className="terms-conditions" onClick={() => this.openPrivacidad()}>
            {' '}
            Aviso de privacidad{' '}
          </div>{' '}
        </div>{' '}
        {this.state.alert_open ? (
          <Alerta option="5" alertEvent={() => this.closeAlert()} />
        ) : (
          ''
        )}{' '}
      </div>
    )
  }
}
reactMixin(HomeModule.prototype, ReactFireMixin)
export default HomeModule



// WEBPACK FOOTER //
// ./src/components/HomeModule.js